import React from 'react';
import PropTypes from 'prop-types';
import GetQuotesForm from '../components/GetQuotesForm';
import { Redirect } from 'react-router-dom';
import { fetchQuestions } from '../actions/questions';
import { fetchCategoryByKey } from '../actions/category';
import { Container, Row, Col, Card, Jumbotron } from '../../legacy/hui/src/styled';
import { requestQuote } from '../actions/quotes';
import { connect } from 'react-redux';
import { getQuestionsByCategoryKey } from '../selectors/questions';
import { TitleBar } from '../components/TitleBar';
import Socium from '../constants/Socium';
import qs from 'querystring';
import styled from 'styled-components';
import ExtraInstallCard from '../components/ExtraInstall/ExtraInstallCard';
import { submitExtraInstallForm, addExtraInstall, removeExtraInstall } from '../actions/extra';
import Category from '../constants/Categories';
import Cookies from 'universal-cookie';
import { composeExtraDataForQuestion } from '../utils/question';

/* style the card and container so the margins/padding/border etc only apply to md up */
const ResponsiveContainer = styled(Container)`
  @media (max-width: ${props => props.theme.breakpoints.md}rem) {
    padding: 0;
  }
`;

const gutter = {
  xs: 0,
  md: 1
};

const ResponsiveCard = styled(Card)`
  @media (max-width: ${props => props.theme.breakpoints.md}rem) {
    border-top: 1px solid ${props => props.theme.defaultBackground};
    margin: 0;
    border-radius: 0;
    padding: 10px;
  }
`;

const JumbotronFU = Jumbotron.extend`
  &:before {
    content: '';
    display: block;
    background: rgba(0, 0, 0, 0);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
  height: 120px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    height: 350px;
  }
`;

const HelpText = Col.extend`
  font-size: 20px;
  color: #0d5257;
`;

const PhoneText = Col.extend`
  font-size: 20px;
  color: #0d5257;
  padding-bottom: 20px;
`;

const WordsText = styled.div`
  font-size: 16px;
  padding-left: 10px;
`;

const heroBackground = (categories, Component) => {
  const id = Array.isArray(categories) && categories[0].categoryId ? categories[0].categoryId : 0;
  if (id === 0) {
    return false;
  }
  return <Component background={Category[id].setting} />;
};

const Enquire = ({
  voucher,
  requestQuote,
  questions = [],
  initialLocation,
  buttonText,
  basePath,
  redirectToHome,
  submitExtraInstallForm,
  addExtraInstall,
  removeExtraInstall,
  extraInstall,
  categories
}) =>
  redirectToHome ? (
    <Redirect to="/install" />
  ) : (
    <React.Fragment>
      <TitleBar pageTitle={'Installation Service'} />
      {heroBackground(categories, JumbotronFU)}
      <ResponsiveContainer>
        <Row gutter={0} style={{ marginBottom: '1em' }}>
          <Col xs={12} md={10} gutter={gutter}>
            <ResponsiveCard snow>
              {voucher.length > 20 && (
                <Col xs={12} style={{ marginRight: 11 }}>
                  <ExtraInstallCard
                    categories={categories}
                    submitExtraInstallForm={submitExtraInstallForm}
                    addExtraInstall={addExtraInstall}
                    removeExtraInstall={removeExtraInstall}
                    extraInstall={extraInstall}
                  />
                </Col>
              )}
              <GetQuotesForm
                categories={categories}
                initialLocation={initialLocation}
                onSubmit={data => requestQuote(data, basePath)}
                questions={questions}
                buttonText={buttonText}
              />
            </ResponsiveCard>
          </Col>
        </Row>

        <Row gutter={0} style={{ marginBottom: '1em' }}>
          <Col xs={12} md={10} gutter={gutter}>
            <Card snow p={0} mt={0.8} mb={1}>
              <Row p="1rem 1.5rem 0 1.5rem">
                <HelpText>Need Help?</HelpText>
              </Row>
              <Row p="1rem 1.5rem 0 1.5rem">
                <WordsText>
                  If you require help at any stage during your install you can call the dedicated
                  support phone line
                </WordsText>
              </Row>
              <Row p="1rem 1.5rem 0 1.5rem">
                <PhoneText>1300 043 520</PhoneText>
              </Row>
            </Card>
          </Col>
        </Row>
      </ResponsiveContainer>
    </React.Fragment>
  );

Enquire.propTypes = {
  voucher: PropTypes.string,
  requestQuote: PropTypes.func,
  questions: PropTypes.array,
  initialLocation: PropTypes.string,
  buttonText: PropTypes.string,
  basePath: PropTypes.string,
  redirectToHome: PropTypes.bool,
  submitExtraInstallForm: PropTypes.func,
  addExtraInstall: PropTypes.func,
  removeExtraInstall: PropTypes.func,
  extraInstall: PropTypes.object,
  categories: PropTypes.array
};

const addDefaultCat = query => (query.cat = query.cat || 'bunnings_toilet_installation');

Enquire.needs = (props, dispatch, query = {}) => {
  addDefaultCat(query);
  const category = query && query.cat ? dispatch(fetchCategoryByKey(query.cat)) : null;
  const questions = query && query.cat ? dispatch(fetchQuestions(query.cat)) : null;
  return Promise.all([category, questions]);
};

export default connect(
  (state, props) => {
    const query = qs.parse(props.location.search.replace('?', ''));
    addDefaultCat(query);
    const { buttonText, basePath } = props.route.props;
    const c = new Cookies();

    const redirectToHome = typeof c.get(Socium.COOKIE_TOKEN) === 'undefined' ? true : false;
    const questions = getQuestionsByCategoryKey(state, query.cat);

    return {
      buttonText,
      voucher: state.install.voucher,
      categories: state.install.categories,
      basePath,
      questions: questions.map(question => composeExtraDataForQuestion(question)),
      initialLocation: query && query.loc,
      redirectToHome: redirectToHome,
      extraInstall: state.extra
    };
  },
  { requestQuote, submitExtraInstallForm, addExtraInstall, removeExtraInstall }
)(Enquire);
